
import type { FC } from 'react'
import { Icon } from '@/components/ui/icon'

export const DeveloperSection: FC = () => {
  return (
    <div className="p-6 flex flex-col gap-6">
      <div>
        <h3 className="text-base font-semibold">Developer</h3>
        <p className="text-sm text-muted-foreground mt-1">
          Developer tools and API access.
        </p>
      </div>

      <div className="rounded-lg border border-dashed border-border p-6 text-center">
        <Icon name="code-2" className="h-8 w-8 text-muted-foreground mx-auto mb-2" />
        <p className="text-sm text-muted-foreground">Developer tools coming soon</p>
      </div>
    </div>
  )
}
